module.exports = __webpack_public_path__ + "img/stylus-c-trans.6907a9fd.png";